<script setup>
import { useBreakpoints } from '@daysmart/daysmart-vue-components/composables'
import { useAppNavMenuMobileState } from '@/core/composables/useAppNavMenuMobileState'

const { currentProviderName, currentProviderLogoUrl, hasOnlyOneProvider } = useSessionData()
const { isHomePage } = useIsHomePage()

const { isOpen } = useAppNavMenuMobileState()
const { isWidget } = useWidgetSettings()

// TODO: close on change breakpoint?
const { current: currentBreakpoint } = useBreakpoints()

const openAndBreakpointIsXs = computed(() => {
  return isOpen.value && currentBreakpoint.value === 'xs'
})

const { t } = useI18n()
</script>

<template>
  <Transition
    appear
    enter-from-class="translate-x--100%"
    enter-active-class="transition-transform duration-600 ease-out"
    enter-to-class="translate-x-0%"
    leave-from-class="translate-x-0%"
    leave-active-class="transition-transform duration-600 ease-out"
    leave-to-class="translate-x--100%"
  >
    <div
      v-if="openAndBreakpointIsXs"
      v-kbd-trap
      v-focus
      class="app-nav-menu-mobile fixed inset-0 z-2000 max-h-100vh flex flex-col bg-white p-4 shadow-lg ring-2 ring-black/30"
      @keydown.esc="isOpen = false"
    >
      <div class="menu-header flex items-center justify-between">
        <div class="flex items-center gap-2">
          <img
            v-if="currentProviderLogoUrl"
            :src="currentProviderLogoUrl"
            alt="Logo"
            width="60"
            height="60"
          >
          <p>{{ currentProviderName }}</p>
        </div>
        <AppNavMenuMobileCloseButton />
      </div>
      <hr class="text-secondary-200 m-block-4">
      <!-- scrollable container -->
      <div class="flex grow flex-col overflow-y-scroll overscroll-contain show-scrollbar">
        <AppNavMenuItemsProvider v-slot="{ navMenuItems, activeItem }">
          <ul class="app-nav-menu-items flex flex-col flex-nowrap justify-start gap-1">
            <li v-if="!isHomePage && !hasOnlyOneProvider">
              <AppNavMenuItem
                url="/dashboard"
                icon="i-far-house"
                icon-alt="i-fas-house"
                :label="t('Home')"
                :v2-link="true"
                :router-link="false"
              />
            </li>
            <template
              v-for="(item, itemIndex) in navMenuItems"
              :key="itemIndex"
            >
              <li v-if="item.visible !== false">
                <AppNavMenuItem
                  v-if="item?.label || item?.icon"
                  v-bind="{ ...item, active: item === activeItem }"
                />
              </li>
            </template>
          </ul>
        </AppNavMenuItemsProvider>
        <AppLoginOrLogoutButton
          v-if="isWidget"
          class="mt-4"
        />
        <AppPoweredByTeamUp />
      </div>
    </div>
  </Transition>
  <Transition
    appear
    enter-from-class="opacity-0"
    enter-active-class="transition-opacity duration-500 ease-out"
    enter-to-class="opacity-100"
    leave-from-class="opacity-100"
    leave-active-class="transition-opacity duration-500 ease-out"
    leave-to-class="opacity-0"
  >
    <div
      v-if="openAndBreakpointIsXs"
      class="overlay fixed inset-0 bg-black/50"
    />
    <!-- TODO: keyboard trap doesn't seem to work the first time through the results ??? -->
  </transition>
</template>

<i18n>
{
  "en-us": {
    "Home": "Home"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Home": "Start"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Home": "Accueil"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Home": "Inicio"
}
</i18n>
